import { Notice } from '@/components/ui/Notice'
import { Section, SectionHeading } from '@/components/ui/Section'
import { SITE } from '@/config/site'
import { useDocumentMeta } from '@/hooks/useDocumentMeta'
import { useI18n } from '@/i18n'

export function AboutPage() {
  const { t } = useI18n()
  useDocumentMeta({ title: t.about.heading, description: t.about.lead })

  return (
    <Section size="narrow">
      <SectionHeading eyebrow={t.about.eyebrow} title={t.about.heading} lead={t.about.lead} />

      <div className="mt-8">
        <Notice>{t.about.placeholderNotice}</Notice>
      </div>

      <div className="mt-10">
        <h2 className="eyebrow mb-4">{t.about.contactHeading}</h2>
        <dl className="space-y-3">
          <div>
            <dt className="sr-only">Email</dt>
            <dd>
              <a
                href={`mailto:${SITE.email}`}
                className="break-all font-serif text-xl text-gold underline-offset-4 hover:underline"
              >
                {SITE.email}
              </a>
            </dd>
          </div>
          <div>
            <dt className="sr-only">Instagram</dt>
            <dd>
              <a
                href={SITE.instagram.url}
                target="_blank"
                rel="noreferrer noopener"
                className="font-serif text-xl text-gold underline-offset-4 hover:underline"
              >
                {SITE.instagram.handle}
              </a>
            </dd>
          </div>
        </dl>
        <p className="mt-4 text-sm text-muted">{t.common.basedIn}</p>
      </div>
    </Section>
  )
}
